import { render, staticRenderFns } from "./PageTabs.vue?vue&type=template&id=c98378ba&scoped=true&"
import script from "./PageTabs.vue?vue&type=script&lang=js&"
export * from "./PageTabs.vue?vue&type=script&lang=js&"
import style0 from "./PageTabs.vue?vue&type=style&index=0&id=c98378ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98378ba",
  null
  
)

export default component.exports